import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['cumulativeReturnLink', 'annualizedReturnLink', 'cumulativeReturn', 'annualizedReturn'];

  cumulativeReturnLinkTarget: HTMLElement;

  annualizedReturnLinkTarget: HTMLElement;

  cumulativeReturnTargets: HTMLElement[];

  annualizedReturnTargets: HTMLElement[];

  onClickCumulativeLink(e: Event) {
    e.preventDefault();
    this.annualizedReturnLinkTarget.classList.add('u-asLink');
    this.cumulativeReturnLinkTarget.classList.remove('u-asLink');
    this.showTargets(this.cumulativeReturnTargets);
    this.hideTargets(this.annualizedReturnTargets);
  }

  onClickAnnualizedLink(e: Event) {
    e.preventDefault();
    this.cumulativeReturnLinkTarget.classList.add('u-asLink');
    this.annualizedReturnLinkTarget.classList.remove('u-asLink');
    this.showTargets(this.annualizedReturnTargets);
    this.hideTargets(this.cumulativeReturnTargets);
  }

  private showTargets(targets: HTMLElement[]) {
    targets.forEach(target => {
      target.classList.remove('u-displayNone');
    });
  }

  private hideTargets(targets: HTMLElement[]) {
    targets.forEach(target => {
      target.classList.add('u-displayNone');
    });
  }
}
